import React, { useEffect } from 'react';

// Types
import { OnboardingWizardStep } from '../OnboardingWizard/types';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import SignUpPage from 'Dashboard/components/SignUpPage/SignUpPage';
import CalendarIntegration2023IntroSlides from './CalendarIntegration2023IntroSlides';
import CalendarIntegration2023InvitedProfile from './CalendarIntegration2023InvitedProfile';
import Terminal from '../OnboardingWizard/Terminal/Terminal';

// Styles
import './CalendarIntegration2023.scss';

const CalendarIntegration2023 = () => {
  const { flowType, step } = useOnboardingState();

  useEffect(() => {
    if (step) {
      (window as any).analytics.identify({ flowType });
      (window as any).analytics.track('Started Onboarding Step', { step }, { integrations: { Calixa: false } });
    }
  }, [step]);

  if (step === OnboardingWizardStep.calendarIntegration2023CreateAccount) return <SignUpPage askForName askForRole />;
  if (step === OnboardingWizardStep.calendarIntegration2023IntroSlides) return <CalendarIntegration2023IntroSlides />;
  if (step === OnboardingWizardStep.profile) return <CalendarIntegration2023InvitedProfile />;
  if (step === OnboardingWizardStep.terminal) return <Terminal />;
};

export default CalendarIntegration2023;
